import { RootState } from 'types/root-state';
import { initialState } from './slice';

export const selectDomain = (state: RootState) => state.spl.roughWork || initialState;

export const selectRoughWorkConfigurators = (state: RootState) =>
	selectDomain(state).data.configurators;
export const selectRoughWorkNetwork = (state: RootState) => selectDomain(state).network;
